// API 클라이언트 내보내기
export { default as apiClient } from './client/axios-client';
export * from './client/types';
export * from './client/error-handler';

// API 컨텍스트 내보내기
export { default as ApiProvider, useApiContext } from './context/api-provider';

// 생성된 API 내보내기 (생성된 파일이 있을 경우만 활성화)
// export * from './generated';

/**
 * API 모듈 사용 가이드
 *
 * 1. API 모듈 초기화:
 *    - ApiProvider를 애플리케이션 최상위에 배치
 *    - 환경 변수 API_URL 설정 (.env 파일)
 *
 * 2. API 스펙 생성:
 *    - npm run update-api-spec: OpenAPI 스펙 다운로드
 *    - npm run generate-api: API 클라이언트 코드 생성
 *
 * 3. 일반적인 사용 방법:
 *    - 데이터 조회: useLoadingQuery
 *    - 데이터 변경: useToastMutation
 *
 * 4. 도메인 서비스 생성:
 *    - 생성된 API 코드를 직접 사용하기보다 도메인 서비스로 래핑
 *    - 예: src/api/services/ 폴더 내에 도메인별 서비스 구현
 *
 * 5. 에러 핸들링:
 *    - 기본적인 에러 처리는 자동으로 수행됨
 *    - 커스텀 에러 처리가 필요한 경우 onError 콜백 사용
 */
